import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './MainScreen.module.scss';
import scenarioRegistry from './scenarioRegistry';
import * as gameEngine from './gameEngine';
import {videoURL, playAudio, resume} from './mediaBundle';
import classNames from 'classnames';

export default class MainScreen extends Component {
    static propTypes = {
        game: PropTypes.object.isRequired,
        onChangeGame: PropTypes.func.isRequired,
    };

    timers = [];

    addTimeout(fn, delay) {
        this.timers.push(setTimeout(fn, delay));
    }

    componentDidMount() {
        //for (let i = 0; i < 6; i++) {
        //    this.addTimeout(() => playAudio('showMCQ'), 1250 + i * 125);
        //}
    }

    componentWillUnmount() {
        this.timers.forEach(clearTimeout);
    }

    render() {
        return (
            <section className={styles.mainScreen}>
                <div className={styles.smallHeader}>Quest 1:</div>
                <div className={styles.smallHeader}>We Got Game</div>
                <header className={styles.header}>Fact or Fiction</header>

                <article className={styles.scenarioList}>
                    {scenarioRegistry.map(this.renderScenarioPreview)}
                </article>
            </section>
        );
    }

    renderScenarioPreview = (scenario, index) => {
        const {game} = this.props;
        const finished = game.finishedScenarios.includes(index);

        const style = this.getPreviewAnimationStyle(index);

        return (
            <div
                key={index}
                className={styles.scenarioPreview}
                style={style}
                onClick={this.selectScenario(index)}
            >
                <div className={styles.previewBlock}>
                    <img className={styles.previewVideo} src={scenario.preview} />
                    {finished && <div className={styles.previewFinished} />}
                </div>
                <div className={styles.scenarioName}>Scenario {index + 1}</div>
            </div>
        );
    };

    getPreviewAnimationStyle(index) {
        const animationIndex = [0, 1, 2, 5, 4, 3][index];
        const animationAppearDuration = 0.5;
        const animationDelay =
            animationAppearDuration / 2 + (animationIndex * animationAppearDuration) / 4;

        return {
            animationDuration: `${animationAppearDuration}s`,
            animationDelay: `${animationDelay}s`,
        };
    }

    selectScenario = scenarioIndex => () => {
        const {game} = this.props;

        resume();
        playAudio('scenarioAppear');

        this.props.onChangeGame({
            ...game,
            scenario: gameEngine.createScenario(scenarioIndex),
            scenarioIndex,
            userChoice: {},
        });
    };
}
